import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function account(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.957 21H4.033C3.463 21 3 20.553 3 20.001v-.42c-.005-2.993 1.583-5.778 4.203-7.371-1.826-2.386-1.485-5.722.79-7.715 2.274-1.993 5.74-1.993 8.014 0 2.275 1.993 2.616 5.33.79 7.715 2.62 1.593 4.208 4.378 4.203 7.372v.42c0 .266-.11.521-.306.709a1.048 1.048 0 01-.737.289zM5 19h14c-.222-2.474-1.862-4.626-4.259-5.592a1.008 1.008 0 01-.63-.78.977.977 0 01.38-.917c1.303-1.005 1.802-2.686 1.243-4.194C15.176 6.008 13.682 5 12.005 5c-1.676 0-3.17 1.008-3.729 2.517-.558 1.508-.06 3.189 1.244 4.194.287.22.43.569.38.917a1.01 1.01 0 01-.63.78C6.867 14.371 5.223 16.524 5 19z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function apple(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.902 2.009c.077.003.134.006.17.009A.998.998 0 0119 3.03a6.346 6.346 0 01-.395 2.04c-.225.602-.54 1.123-.97 1.531l-.09.079C19.752 7.726 21 10.225 21 13.522c0 3.604-2.362 7.18-5.597 8.348-.737.266-1.177.127-2.408-.456l-.18-.085c-.43-.2-.68-.282-.815-.282-.12.005-.306.087-.732.33-1.042.599-1.498.765-2.274.499C5.422 20.65 3 17.325 3 13.522c0-3.715 1.302-6.2 3.963-7.158 1.608-.578 2.771-.46 4.143.129l-.121-.049a.983.983 0 01-.036-.267c0-1.29-.61-1.948-2.108-2.19a1 1 0 11.318-1.974c1.727.278 2.91 1.095 3.453 2.37.214-.46.484-.856.813-1.185.542-.544 1.309-.863 2.243-1.04a10.118 10.118 0 012.234-.15zm-7.587 6.319c-.942-.405-1.599-.471-2.674-.085C5.888 8.874 5 10.57 5 13.522c0 2.942 1.873 5.514 4.644 6.465-.004-.002.01-.009.048-.028l.131-.067c.1-.051.245-.13.449-.246.709-.407 1.078-.568 1.625-.594l.103-.003c.52 0 .971.15 1.658.47l.194.09c.627.297.883.378.87.383 2.42-.874 4.278-3.686 4.278-6.47 0-2.679-.945-4.48-2.468-5.106-1.095-.45-1.746-.409-2.81-.016a17.08 17.08 0 01-.595.216c-.255.085-.48.143-.708.177-.14.021-.28.032-.419.032h-.02a2.734 2.734 0 01-.948-.194 7.912 7.912 0 01-.375-.154l-.342-.15zM10 9.99a1 1 0 110 1.998c-.77 0-.985.217-.985.998a1 1 0 11-2 0c0-1.881 1.108-2.996 2.985-2.996zm6.842-5.97c-.27.019-.541.052-.802.101-.575.109-.996.284-1.198.487-.277.277-.498.7-.65 1.273 1.032-.149 1.724-.405 2.067-.73.185-.175.346-.44.471-.778.043-.113.08-.232.112-.353z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function atm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M4 18v1h16v-1h2v2l-.007.117a.999.999 0 01-.876.876L21 21H3l-.117-.007a.999.999 0 01-.876-.876L2 20v-2h2zm10-9v1.5h-2.25V15h-1.5v-4.5H8V9h6zM6 9c.55 0 1 .45 1 1v5H5.5v-1.5h-2V15H2v-5c0-.55.45-1 1-1zm15 0c.55 0 1 .45 1 1v5h-1.5v-4.51h-1V14H18v-3.5h-1V15h-1.5v-5c0-.55.45-1 1-1zM5.5 10.5h-2V12h2v-1.5zM21 3a1 1 0 01.993.883L22 4v2h-2V5H4v1H2V4a1 1 0 01.883-.993L3 3h18z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function bakery(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 6a2 2 0 002-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm6 3h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v9c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-9c0-1.66-1.34-3-3-3zm1 11H5v-3c.9-.01 1.76-.37 2.4-1.01l1.09-1.07 1.07 1.07c1.31 1.31 3.59 1.3 4.89 0l1.08-1.07 1.07 1.07c.64.64 1.5 1 2.4 1.01v3zm0-4.5c-.51-.01-.99-.2-1.35-.57l-2.13-2.13-2.14 2.13c-.74.74-2.03.74-2.77 0L8.48 12.8l-2.14 2.13c-.35.36-.83.56-1.34.57V12c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.5z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function barcode(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 6h3v3a1 1 0 002 0V5a1 1 0 00-1-1h-4a1 1 0 000 2zM4 9V6h3a1 1 0 000-2H3a1 1 0 00-1 1v4a1 1 0 002 0zm3 9H4v-3a1 1 0 00-2 0v4a1 1 0 001 1h4a1 1 0 000-2zm13-3v3h-3a1 1 0 000 2h4a1 1 0 001-1v-4a1 1 0 00-2 0zM6 8h2v8H6V8zm6 0h1v8h-1V8zM9 8h2v8H9V8zm8 0h1v8h-1V8zm-3 0h2v8h-2V8z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function beer(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11 1h2v12h1v-2a1.5 1.5 0 011.356-1.493L15.5 9.5 16 5h3l.5 4.5A1.5 1.5 0 0121 11v2h1v9H2v-9h1v-2a1.5 1.5 0 011.356-1.493L4.5 9.5 5 5h3l.5 4.5A1.5 1.5 0 0110 11v2h1V1zm9 14H4v5h16v-5zM8 11.5H5V13h3v-1.5zm11 0h-3V13h3v-1.5zM8 3v1H5V3h3zm11 0v1h-3V3h3z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function calendar(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 2a1 1 0 011 1v1h2a1 1 0 011 1v15a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1h2V3a1 1 0 012 0v1h8V3a1 1 0 011-1zm2 9H5v8h14v-8zm0-5H5v3h14V6z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function carWash(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16.646 8a2 2 0 011.857 1.257l.807 2.02A.995.995 0 0120 11h1a1 1 0 010 2h-.764c.475.53.764 1.232.764 2v4a1 1 0 01-1 1h-1v1a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H8v1a1 1 0 01-1 1H6a1 1 0 01-1-1v-1H4a1 1 0 01-1-1v-4c0-.768.289-1.47.764-2H3a1 1 0 010-2h1c.267 0 .51.105.69.276l.807-2.019A2 2 0 017.354 8h9.292zm0 2H7.354l-1.201 3H13.5a.5.5 0 010 1H5.651l-.27.214A.995.995 0 005 15v3h14v-3a.994.994 0 00-.381-.786L18.348 14H16.5a.5.5 0 010-1h1.346l-1.2-3zM17 15a1 1 0 110 2 1 1 0 010-2zm-3.5 1a.5.5 0 010 1h-3a.5.5 0 010-1h3zM7 15a1 1 0 110 2 1 1 0 010-2zm5-12l.306.763C12.769 4.948 13 5.693 13 6a1 1 0 01-2 0c0-.368.333-1.368 1-3zM8 2l.306.763C8.769 3.948 9 4.693 9 5a1 1 0 01-2 0c0-.368.333-1.368 1-3zm8 0l.306.763C16.769 3.948 17 4.693 17 5a1 1 0 01-2 0c0-.368.333-1.368 1-3z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function caseIcon(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M20 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16zm-1 2H5v10h2l2 2h6l2-2h2V5zM8 12a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM8 9a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM8 6a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function coupons(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M14 19a1 1 0 010 2h-4a1 1 0 010-2h4zM4 17a1 1 0 011 1v1h1a1 1 0 010 2H5a2 2 0 01-2-2v-1a1 1 0 011-1zm16 0a1 1 0 011 1v1a2 2 0 01-2 2h-1a1 1 0 010-2h1v-1a1 1 0 011-1zM12.092 7c.433 0 .797.324.844.751v.161a3.03 3.03 0 011.841 1.275.87.87 0 01-.202 1.175.841.841 0 01-1.184-.201 1.365 1.365 0 00-1.294-.713c-.91 0-1.264.482-1.264.894a.736.736 0 00.212.528.751.751 0 00.526.225h1.011a2.438 2.438 0 01.324 4.85v.12a.84.84 0 01-.393.806c-.276.172-.627.172-.903 0s-.429-.485-.393-.806v-.08a2.462 2.462 0 01-2.084-2.009.834.834 0 01.597-.903c.455-.13.88.15 1.082.723.262.41.715.66 1.204.662.708 0 1.264-.512 1.264-.923a.74.74 0 00-.212-.529.75.75 0 00-.526-.224l-1.177-.001a2.448 2.448 0 01-2.36-2.297 2.444 2.444 0 012.242-2.572v-.16A.848.848 0 0112.092 7zM20 9a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zM4 9a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm15-6a2 2 0 012 2v1a1 1 0 01-2 0V5h-1a1 1 0 010-2zM6.033 3c.558 0 1.01.446 1.01.996s-.452.997-1.01.997H5.022v.996c0 .55-.453.996-1.011.996A1.003 1.003 0 013 5.99v-.996C3 3.893 3.905 3 5.022 3zM14 3a1 1 0 010 2h-4a1 1 0 010-2h4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function creditCard(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M21 4H3a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1zm-1 2v2H4V6h16zM4 18v-6h16v6H4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function curbside(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.027 15.146a.506.506 0 01.712 0l2.005 1.989a.494.494 0 010 .745l-2.004 1.99a.506.506 0 01-.842-.224.498.498 0 01.13-.482L13.2 18H5.9c-.963.016-1.87-.502-2.425-1.283a.495.495 0 01.14-.67c.22-.151.522-.156.685.053.368.514.965.917 1.6.9h7.3l-1.173-1.148a.497.497 0 010-.706zM12 5c1.925 0 5 3 5 3 2.769 0 5 2.255 5 5a1 1 0 01-1 1h-1.6c-.1 1.1-1.2 2-2.4 2s-2.163-.842-2.4-2H9.4c-.227 1.17-1.198 2-2.4 2s-2.173-.83-2.4-2H3c-.28-.014-.521-.087-.7-.3-.179-.213-.337-.625-.3-.9.094-1.582.483-3.11 1.132-4.559C3.673 7.027 4.485 5.934 5.6 5.2c.19-.15.458-.181.7-.2zm-5 7c-.828 0-1.5.674-1.5 1.505.002.157.029.313.08.461A1.48 1.48 0 006.99 15a1.48 1.48 0 001.41-1.034c.058-.147.092-.303.1-.461C8.5 12.674 7.828 12 7 12zm10.153.008a1.5 1.5 0 10-.306 2.985 1.5 1.5 0 00.306-2.986zM12 7H6.7c-.714.508-1.337 1.206-1.7 2h.5a.5.5 0 010 1h-.9c-.213.648-.406 1.325-.5 2H5c.466-.637 1.206-1 2-1s1.534.363 2 1h6c.469-.606 1.23-1 2-1s1.531.394 2 1h.9c-.398-1.19-1.635-2.004-2.9-2H9.5a.5.5 0 010-1h5.6c-.922-.883-1.894-1.572-3.1-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function currentLocation(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M12 1a1 1 0 011 1l.001 2.062A8.004 8.004 0 0119.938 11H22a1 1 0 010 2l-2.062.001a8.004 8.004 0 01-6.937 6.937L13 22a1 1 0 01-2 0v-2.062a8.004 8.004 0 01-6.938-6.937L2 13a1 1 0 010-2h2.062A8.004 8.004 0 0111 4.062V2a1 1 0 011-1zm0 5a6 6 0 100 12 6 6 0 000-12zm0 2a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
        fill={checkColor(color)}
        fillRule="evenodd"
        data-testid="ads-icon__path"
      />
    </svg>
  );
}

export function debug(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M1.39 18.99l9.08-9.08c-.93-2.34-.45-5.1 1.44-7 2.3-2.3 5.88-2.51 8.43-.65L16.5 6.11l1.42 1.41 3.83-3.83c1.86 2.54 1.65 6.13-.65 8.42-1.86 1.86-4.57 2.35-6.89 1.48L5.1 22.7a.996.996 0 01-1.41 0l-2.3-2.3a.978.978 0 010-1.41zm3 1.6l9.46-9.46c.61.45 1.29.72 2 .82 1.36.2 2.79-.21 3.83-1.25.95-.94 1.39-2.2 1.32-3.44l-3.09 3.09-4.24-4.24 3.09-3.09c-1.24-.07-2.49.37-3.44 1.31a4.469 4.469 0 00-1.24 3.96c.12.71.42 1.37.88 1.96L3.51 19.7l.88.89z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function deli(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M2 19c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3H2v3zm2-1h16v1H4v-1zm14.66-6.5c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.32 1l-.01-1.98c-1.61-.33-1.62-1.02-3.33-1.02zM22 9c.02-4-4.28-6-10-6C6.29 3 2 5 2 9v1h20V9zM4.18 8C5.01 5.81 8.61 5 12 5c3.31 0 5.93.73 7.19 1.99.3.31.52.64.65 1.01H4.18z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function delivery(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M21.567 8c.45 0 .868.222 1.118.592l4.222 6.275 3.145 1.187c.549.182.919.69.919 1.262v4.64l-.002.019h.002v1.331h-2.754a3.316 3.316 0 01-.916 1.688 3.368 3.368 0 01-2.375.974 3.37 3.37 0 01-2.375-.974 3.316 3.316 0 01-.916-1.688h-6.72a3.316 3.316 0 01-.916 1.688 3.368 3.368 0 01-2.375.974 3.37 3.37 0 01-2.375-.974 3.317 3.317 0 01-.916-1.687H5.45l-.003-5.99H6.79v4.64h1.547c.136-.645.46-1.223.911-1.67a3.368 3.368 0 012.375-.974c.925 0 1.769.374 2.375.974.451.447.775 1.025.911 1.67h6.73c.136-.645.46-1.223.911-1.67a3.368 3.368 0 012.375-.974c.925 0 1.769.374 2.375.974.451.447.775 1.025.911 1.669h1.415v-4.64l-3.582-1.33h-6.361v-5.325h2.779l-.896-1.33H8.133L6.79 13.323H2.086v-1.33h3.736L6.859 8.91c.184-.544.697-.91 1.275-.91zm-9.943 12.644a2.021 2.021 0 00-1.425.585 1.987 1.987 0 000 2.823 2.03 2.03 0 002.851 0 1.985 1.985 0 00-.001-2.823 2.021 2.021 0 00-1.425-.585zm13.302 0a2.018 2.018 0 00-1.425.585 1.983 1.983 0 000 2.823 2.02 2.02 0 001.425.585c.554 0 1.062-.225 1.424-.585a1.983 1.983 0 00.001-2.823 2.026 2.026 0 00-1.425-.585zm-.002 1.258c.413 0 .747.331.747.739a.742.742 0 01-.747.738.74.74 0 01-.743-.738.74.74 0 01.743-.739zm-13.301 0c.412 0 .747.331.747.739a.743.743 0 01-.747.738.74.74 0 01-.744-.738.74.74 0 01.744-.739zm-9.536-7.32c.413 0 .747.331.747.738a.742.742 0 01-.747.738.74.74 0 01-.744-.738.74.74 0 01.744-.738zm4.704.073v1.331H3.429v-1.331h3.362zm16.567-2.662h-2.331v2.662h4.122l-1.791-2.662zM.744 11.92c.412 0 .746.331.746.738a.742.742 0 01-.746.738.74.74 0 01-.744-.738.74.74 0 01.744-.738z"
        fill="#0C60A5"
      />
      <path
        d="M12.31 13.91c0-.421.035-.707.107-.857.072-.149.218-.224.437-.224.179 0 .291.053.342.154.05.104.075.33.075.676v3.092h1.373v-2.84c0-.435.033-.724.1-.867.066-.143.21-.215.428-.215.183 0 .302.055.354.163.053.111.08.348.08.71v3.05h1.374v-3.189c0-.557-.038-.936-.113-1.137a.929.929 0 00-.402-.476c-.192-.117-.451-.174-.774-.174-.583 0-.985.255-1.208.762-.122-.507-.476-.762-1.059-.762-.56 0-.957.255-1.19.762v-.676h-1.299v4.888h1.374v-2.84"
        fill="#DB232D"
      />
    </svg>
  );
}

export function direction(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.5 21h-.127a.982.982 0 01-.834-.778l-1.12-5.633-5.624-1.142a.986.986 0 01-.245-1.852l15.077-7.513a.977.977 0 011.098.22.986.986 0 01.178 1.11l-7.529 15.046a.98.98 0 01-.873.542zM7 12.1l4.087.823L11.9 17l4.9-9.8L7 12.1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function ebtCard(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M21 4a1 1 0 01.993.883L22 5v14a1 1 0 01-.883.993L21 20H3a1 1 0 01-.993-.883L2 19V5a1 1 0 01.883-.993L3 4h18zm-1 12H4v2h16v-2zm0-10H4v8h16V6zm-8.036 1.99v.763h-1.605v.805h1.365v.757h-1.365v.922h1.666V12h-2.57V7.99h2.509zm2.132 0l.204.005c.133.007.258.02.377.041.179.031.334.085.468.163.133.078.238.18.313.308a.922.922 0 01.114.48 1.078 1.078 0 01-.141.522.985.985 0 01-.163.21.622.622 0 01-.219.135v.024l.1.03a.897.897 0 01.411.278.888.888 0 01.154.273c.036.105.055.225.055.36 0 .205-.04.381-.12.53-.08.147-.19.269-.332.365a1.545 1.545 0 01-.495.215 2.517 2.517 0 01-.609.071h-1.488V7.99h1.371zm4.87 0v.763h-1.102V12h-.91V8.753h-1.1V7.99h3.111zm-4.827 2.276h-.51v1.033h.51c.496 0 .744-.18.744-.541 0-.177-.061-.303-.184-.379-.123-.075-.31-.113-.56-.113zm-.08-1.575h-.43v.904h.424c.221 0 .382-.043.483-.129.1-.086.15-.2.15-.344 0-.156-.05-.267-.153-.332-.103-.066-.26-.099-.474-.099z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function expressPickup(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.917 3.325a.791.791 0 011.05-.21l6.727 4.537a.8.8 0 01.149 1.105l-7.926 11.879a.79.79 0 01-1.06.258l-6.648-4.586a.8.8 0 01-.217-1.104zm.99 1.651l-6.2 9.234 5.112 3.462 6.202-9.233-5.112-3.462zM4 10a1 1 0 110 2 1 1 0 010-2zm2-3a1 1 0 010 2H4a1 1 0 010-2h2zm2-3a1 1 0 010 2H4a1 1 0 010-2h4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function ev(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 11v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2V6z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function familyCare(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.638 11.082a4.587 4.587 0 00-.825-5.956 4.556 4.556 0 00-5.997 0 4.587 4.587 0 00-.825 5.956A6.773 6.773 0 002 16.681V19c0 .552.45 1 1 1h11.602a1 1 0 00.997-1v-2.31a6.805 6.805 0 00-2.223-5.018 6.862 6.862 0 00-.738-.59zm-5.683 1.2a1.001 1.001 0 00.24-1.7 2.582 2.582 0 01-.805-2.865 2.573 2.573 0 012.425-1.718c1.089 0 2.06.688 2.424 1.718a2.583 2.583 0 01-.804 2.865c-.273.221-.41.57-.362.918.05.348.278.645.601.782a4.788 4.788 0 012.911 4.409V18H4.054v-1.31a4.78 4.78 0 012.901-4.41zm12.832.77a6.862 6.862 0 00-.738-.59 4.58 4.58 0 00-.274-5.385 4.548 4.548 0 00-5.2-1.374c.169.28.312.575.429.88.12.324.21.659.27 1a2.568 2.568 0 013.224 1.075 2.584 2.584 0 01-.653 3.344.955.955 0 00-.345.898c.049.348.261.665.585.802A4.77 4.77 0 0120 18h-3.4v1a2.037 2.037 0 01-.303 1h4.706A1 1 0 0022 19v-.93a6.806 6.806 0 00-2.213-5.018z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function findAStore(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16 22H7.999a1 1 0 110-2h8a1 1 0 110 2zM12 4a4 4 0 014 4 4.001 4.001 0 01-.8 2.39L12 15.07l-3.131-4.62a3.997 3.997 0 01-.536-3.81 3.997 3.997 0 012.926-2.5 4.33 4.33 0 01.74-.14zm0-2c-.397 0-.792.036-1.181.11a5.998 5.998 0 00-3.621 9.48l4.181 6.1a.8.8 0 001.28 0l4.14-6.09A6 6 0 0012 2zm-1.471 5.51a1.49 1.49 0 112.98 0 1.49 1.49 0 01-2.98 0"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function food(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9.101 4.151c1.736 1.76 1.776 3.11 1.273 4.809l1.665 1.665 7.071-7.07c.354-.354 1.061-.354 1.415 0 .1.1.355.39.565.848.506 1.104.448 3.523-1.1 5.325l-.172.19-2.122 2.121c-.36.358-.928.386-1.32.083l-.094-.083-1.414-1.414-1.415 1.414 7.032 7.032c.283.283.495.92 0 1.414-.495.495-1.13.283-1.414 0l-7.032-7.032-7.07 7.072c-.284.282-.92.495-1.415 0-.462-.462-.308-1.048-.055-1.353l.055-.062 7.071-7.071-1.665-1.665c-1.687.523-3.033.487-4.809-1.273-1.776-1.76-1.946-4.266-.636-5.586 1.31-1.32 3.85-1.124 5.586.636zm10.504 1.737L16.282 9.21l.707.707 1.697-1.697c.507-.534 1.042-1.608.92-2.333zM4.93 4.929c-.586.586-.27 1.852.707 2.828.976.977 2.243 1.293 2.829.708.585-.586.269-1.853-.708-2.829-.976-.976-2.242-1.293-2.828-.707z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function forklift(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 2a1 1 0 011 1v14h3a1 1 0 010 2l-3.337.001a3.502 3.502 0 01-6.326 0H9.83A3.003 3.003 0 014.171 19H4a2.001 2.001 0 01-1.995-1.85L2 17v-6c0-1.054.816-1.918 1.85-1.995L4 9h1V7a2 2 0 011.697-1.977l.154-.018L7 5h5a2 2 0 011.71.964l.079.142L16 10.529V3a1 1 0 011-1zM7 17a1 1 0 100 2 1 1 0 000-2zm7.5-1a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0014.5 16zm-4.809-5H4v6h.17a3.003 3.003 0 015.66 0h1.205c.095-.66.373-1.26.78-1.746L9.692 11zM12 7H7v3h3c.19 0 .363.107.447.276l2.144 4.29A3.486 3.486 0 0114.5 14c.38 0 .744.06 1.086.172L12 7z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function gas(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.45 7.63L16.81 5a.502.502 0 00-.71.71l1.39 1.39A2 2 0 0018 11c.352-.004.697-.1 1-.28v8a1 1 0 01-2 0V14a2 2 0 00-2-2h-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v16a1 1 0 001 1h8a1 1 0 001-1v-7h1a1 1 0 011 1v4.71a2 2 0 104 0V9c-.002-.51-.199-1-.55-1.37zM12 19H6v-8h6v8zm0-10H6V5h6v4zm6 1a1 1 0 110-2 1 1 0 010 2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function giftCards(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.702 4.031a3.427 3.427 0 015.964.568 3.849 3.849 0 01-.153 3.402L21 8a1 1 0 011 1v11a1 1 0 01-1 1H3a1 1 0 01-1-1V9a1 1 0 011-1h1.477a3.848 3.848 0 01-.153-3.4 3.428 3.428 0 015.964-.569l1.706 2.482zM20 17H4v2h16v-2zm0-7h-4.391l1.905 1.143a1 1 0 01-.925 1.769l-.103-.055L12 10.166l-4.486 2.691a1 1 0 01-1.306-.246l-.065-.097a1 1 0 01.246-1.306l.097-.065L8.39 9.999 4 10v4h16v-4zm-2.79-5.28a1.428 1.428 0 00-1.86.444L13.4 8h2.734c.205 0 .408-.034.6-.1l.144-.056a1.855 1.855 0 00.956-2.443 1.428 1.428 0 00-.5-.604zm-10.43 0l-.125.077c-.219.15-.392.36-.498.604a1.854 1.854 0 00.956 2.443l.143.056c.193.066.396.1.6.1h2.734L8.64 5.164a1.428 1.428 0 00-1.86-.444z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function handTruck(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10.41 18.987a1.5 1.5 0 11-2.818 1.025 1.5 1.5 0 012.818-1.025zM5.686 4.272l.021.02L7.7 6.286a.986.986 0 01.254.415l3.692 11.075 6.079-1.737a1 1 0 01.576 1.915l-.027.008-6.806 1.944a2.503 2.503 0 00-2.183-2.89L6.126 7.54 4.293 5.707a1 1 0 011.393-1.435zm10.543 7.642l.009.026.651 1.891a1 1 0 01-.593 1.262l-.027.01-2.836.976a1 1 0 01-1.262-.594l-.01-.026-.65-1.891a1 1 0 01.593-1.262l.026-.01 2.837-.976a1.002 1.002 0 011.262.594zM14.04 8.55l.01.026.308.951a1 1 0 01-.615 1.251l-.027.009-1.902.618a.998.998 0 01-1.25-.615l-.01-.027-.309-.951a1 1 0 01.616-1.251l.026-.009 1.902-.618a1 1 0 011.251.616z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function healing(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.156 11.996l3.572-3.573a.893.893 0 000-1.265l-3.895-3.895a.893.893 0 00-1.265 0l-3.572 3.572-3.573-3.572a.895.895 0 00-1.265 0L3.263 7.158a.893.893 0 000 1.265l3.572 3.573-3.572 3.572a.893.893 0 000 1.265l3.895 3.895c.35.35.915.35 1.265 0l3.573-3.572 3.572 3.572c.18.18.404.26.637.26a.916.916 0 00.637-.26l3.895-3.895a.893.893 0 000-1.265l-3.58-3.572zm-5.143-2.711a.9.9 0 01.898.897.9.9 0 01-.898.898.9.9 0 01-.897-.898.9.9 0 01.897-.897zm-4.227 1.76l-3.258-3.25 3.258-3.258 3.25 3.25-3.25 3.257zm2.432 1.83a.9.9 0 01-.897-.897.9.9 0 01.897-.898.9.9 0 01.898.898.9.9 0 01-.898.897zm1.795 1.795a.9.9 0 01-.897-.897.9.9 0 01.897-.898.9.9 0 01.898.898.9.9 0 01-.898.897zm1.796-3.59a.9.9 0 01.897.898.9.9 0 01-.897.897.9.9 0 01-.898-.897.9.9 0 01.898-.898zm2.387 8.383l-3.258-3.25 3.258-3.257 3.249 3.249-3.249 3.258z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function hrs(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M8.464 2.808L7.05 8.464l-1.37-1.37a8 8 0 0011.633 10.887l.184-.168c.054-.051.107-.103.16-.156l1.414 1.414-.148.145c-3.915 3.76-10.138 3.711-13.994-.145-3.667-3.666-3.89-9.472-.673-13.4l-1.448-1.45 5.656-1.413zm10.899 12.327l1.84.785a10.104 10.104 0 01-.842 1.568l-.253.366-1.62-1.172a7.97 7.97 0 00.727-1.222l.148-.325zM8.838 8.5c.344 0 .657.052.939.157.282.104.525.252.73.443.205.192.362.42.472.687a2.34 2.34 0 01-.022 1.78c-.124.3-.29.599-.5.898-.208.3-.446.599-.713.898-.267.3-.543.593-.829.882.176-.022.372-.041.587-.06.216-.018.409-.027.577-.027h1.405V15.5H6.577v-.909l.327-.303c.32-.298.62-.581.897-.85.37-.356.688-.691.955-1.005.267-.314.476-.606.626-.877.15-.27.225-.528.225-.773 0-.34-.088-.597-.264-.774-.175-.176-.417-.265-.724-.265-.256 0-.483.07-.68.211-.198.14-.385.305-.56.492L6.5 9.593l.173-.173a3.81 3.81 0 01.88-.644c.36-.184.788-.276 1.285-.276zm7.86.13v4.014h.802v1.211h-.801V15.5h-1.504v-1.645h-3.02v-1.092l2.548-4.133h1.976zm5.289 2.856l.01.27a10.094 10.094 0 01-.087 1.586l-.065.42-1.969-.35A8.01 8.01 0 0020 12.055l-.005-.325-.005-.143 1.997-.101zM15.26 9.993h-.043l-.135.284-.14.29c-.095.194-.194.389-.296.584l-.922 1.493h1.47v-1.115l.002-.174c.003-.18.01-.38.02-.6.015-.291.03-.546.044-.762zm5.53-2.764c.284.521.52 1.068.707 1.632l.13.427-1.925.542a7.851 7.851 0 00-.506-1.33l-.163-.316 1.757-.955zm-2.929-3.332c.481.349.93.739 1.342 1.166l.302.328-1.5 1.322a7.976 7.976 0 00-1.033-.98l-.284-.216 1.173-1.62zM13.678 2.14c.589.1 1.165.252 1.722.453l.415.16-.763 1.85a7.905 7.905 0 00-1.357-.423l-.35-.068.333-1.972zm-2.139-.13l.091 1.998a8.155 8.155 0 00-1.14.134l-.373.08-.468-1.944c.493-.119.996-.2 1.507-.243l.383-.025z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function ice(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 2c.961 0 1.369 1.223.6 1.8l-1.961 1.471A8.504 8.504 0 0122 13.5V20a2 2 0 01-2 2H4a2 2 0 01-2-2v-6.5a8.504 8.504 0 016.361-8.229L6.4 3.8C5.631 3.223 6.039 2 7 2zm-3.5 5h-3a6.5 6.5 0 00-6.496 6.267L4 13.5V20h16v-6.5a6.5 6.5 0 00-6.267-6.496L13.5 7zm-6 4v6.5H6V11h1.5zm5 0a1 1 0 01.993.883L13.5 12v1.5H12v-1h-1.5V16H12v-1h1.5v1.5a1 1 0 01-.883.993l-.117.007H10a1 1 0 01-.993-.883L9 16.5V12a1 1 0 01.883-.993L10 11h2.5zm5.5 0v1.5h-1.5v1h1V15h-1v1H18v1.5h-3V11h3zm-4-7h-4l1.333 1h1.334L14 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function kerosene(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10 2v3l1.382.345.405-1.617a2 2 0 012.28-1.486l.146.03 4.06 1.015a2 2 0 011.485 2.28l-.03.146-.406 1.622.029.01a.998.998 0 01.649.936V21a1 1 0 01-1 1H5a1 1 0 01-1-1V2h6zM8.269 6.001L5.999 6 6 20h12V9.061l-8.485-2.12a2.001 2.001 0 01-1.246-.94zM10.5 10v2.917L13.418 10h2.123l-4.001 4 4.001 4h-2.122L10.5 15.081V18H9v-8h1.5zm3.228-5.787l-.405 1.617 4.059 1.015.405-1.617-4.06-1.015zM8 4H6l-.001 1h2L8 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function location(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M5.392 5.147A7.502 7.502 0 0119 9.49a7.463 7.463 0 01-1.492 4.494L12.331 21.6a1.001 1.001 0 01-1.602 0l-5.237-7.616a7.493 7.493 0 01-.1-8.837zm9.81.267a5.499 5.499 0 00-7.395 0 5.493 5.493 0 00-.703 7.359l4.396 6.555 4.396-6.555h.01a5.493 5.493 0 00-.703-7.359zM11.5 7.018a1.962 1.962 0 11.002 3.924 1.962 1.962 0 01-.002-3.924z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function lotto(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M3.5 16v3.5H5V21H2v-5h1.5zm10 0v1.5h-1V21H11v-3.5h-1V16h3.5zm4 0v1.5h-1V21H15v-3.5h-1V16h3.5zm-10 0c1.054 0 1.918.816 1.995 1.85L9.5 18v1a2 2 0 01-3.995.15L5.5 19v-1a2 2 0 012-2zM20 16c1.054 0 1.918.816 1.995 1.85L22 18v1a2 2 0 01-3.995.15L18 19v-1a2 2 0 012-2zM7.5 17.5a.5.5 0 00-.492.41L7 18v1a.5.5 0 00.992.09L8 19v-1a.5.5 0 00-.5-.5zm12.5 0a.5.5 0 00-.492.41L19.5 18v1a.5.5 0 00.992.09L20.5 19v-1a.5.5 0 00-.5-.5zM18.365 5.084A4.5 4.5 0 0117.5 14c-.526 0-1.03-.09-1.5-.256a6.998 6.998 0 001.755-1.758 2.498 2.498 0 001.225-4.501 6.908 6.908 0 00-.615-2.401zm-12.73 0c-.34.74-.554 1.55-.616 2.402l-.117.091a2.5 2.5 0 001.344 4.41 7.015 7.015 0 001.752 1.757 4.5 4.5 0 11-2.364-8.661zM12 2a6 6 0 110 12 6 6 0 010-12zm0 2C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm2 2l-2 4.5h-1.5l1.5-3h-2V6h4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function meijerM(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M7.438 5.932V7.74c.617-1.36 1.668-2.04 3.15-2.04 1.544 0 2.479.68 2.804 2.04.59-1.36 1.655-2.04 3.193-2.04.859 0 1.544.154 2.053.465.508.31.862.734 1.062 1.272.2.538.3 1.551.3 3.04V19h-3.637v-8.15c0-.973-.07-1.606-.211-1.899-.14-.293-.452-.44-.936-.44-.58 0-.96.192-1.135.576-.176.384-.263 1.156-.263 2.318V19h-3.636v-8.267c0-.93-.067-1.532-.199-1.807-.132-.276-.433-.415-.902-.415-.58 0-.966.202-1.157.602-.192.4-.288 1.165-.288 2.292V19H4V5.932h3.438z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function messages(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M21.002 5a1 1 0 011 1.072v11.89a1.05 1.05 0 01-.024.25l-.009.035c-.004.018-.01.035-.015.053a.982.982 0 01-.842.694L21 19H3a.985.985 0 01-.937-.65l-.017-.05-.015-.053-.009-.035a.995.995 0 01-.023-.267L2 6v-.034l.004-.051a.983.983 0 01.19-.506l.018-.024.028-.035.044-.05a.978.978 0 01.718-.3l-.015.001L3 5zM9.751 13.337L5.631 17H18.37l-4.12-3.661-1.584 1.408a.998.998 0 01-1.23.078l-.098-.078-1.587-1.41zM20 8.228l-4.245 3.773L20 15.773V8.228zM4 8.225v7.547l4.245-3.774L4 8.225zM18.371 7H5.632l6.37 5.661.742-.66-.001-.001 1.506-1.338.001.001L18.371 7z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function mFuel(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.869 2C14.491 2 15 2.51 15 3.135V9.07c-.706.1-1.378.307-2 .603V4H5v12h4c0 .695.101 1.367.29 2H5v2h5.255a7.015 7.015 0 002.14 2.001L4.131 22C3.51 22 3 21.49 3 20.866V3.135C3 2.51 3.51 2 4.132 2h9.737zM16 10a6 6 0 110 12 6 6 0 010-12zm0 1a5 5 0 10.001 10.001A5 5 0 0016 11zm.102 1a.67.67 0 01.66.576l.007.1v.151a2.394 2.394 0 011.402 1.01.7.7 0 01-.159.937.66.66 0 01-.925-.161 1.07 1.07 0 00-.995-.575c-.716 0-.995.383-.995.716a.593.593 0 00.485.596l.092.01h.826c.51.005.995.215 1.352.584.356.369.553.866.548 1.383a1.941 1.941 0 01-1.531 1.911l-.15.026v.06a.672.672 0 01-.667.676.67.67 0 01-.659-.576l-.007-.1v-.06a2.002 2.002 0 01-1.631-1.594.666.666 0 01.467-.727c.348-.1.686.121.846.585.213.346.592.55.994.535.557 0 .995-.403.995-.736a.6.6 0 00-.165-.424.585.585 0 00-.32-.173l-.092-.009h-.826c-1.032.014-1.892-.8-1.95-1.846a1.95 1.95 0 011.58-2.036l.152-.022v-.141c0-.373.298-.676.666-.676zM7.53 8.657v.7c.194-.356.566-.578.97-.58a.865.865 0 01.97.666 1.088 1.088 0 011.122-.666 1 1 0 011.073.975l-.004.117v.638a7.05 7.05 0 00-1.188 1.198v-1.623c0-.422-.77-.387-.873-.071l-.011.071v3.106a5.04 5.04 0 00-.072.169h-1.11V10.03c0-.41-.77-.45-.873-.084l-.011.084v3.289H6.348V8.657h1.181zM11 5v1H7V5h4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function offer(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.975 3a.994.994 0 00-.708.29l-8.972 9a1 1 0 000 1.42l7.038 7.03c.19.174.41.267.667.26.265.002.55-.103.739-.29l8.972-9c.17-.171.273-.399.289-.64V4c0-.552-.446-1-.997-1h-7.028zm.425 2h5.606L19 10.7l-8 7.95L5.398 13 13.4 5zM17 6a1 1 0 100 2 1 1 0 000-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function optical(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M21 11h-.14a4.016 4.016 0 00-3.098-2.925A3.983 3.983 0 0013.8 9.608 2.938 2.938 0 0012 9a2.863 2.863 0 00-1.81.608 3.98 3.98 0 00-3.962-1.533 4.016 4.016 0 00-3.098 2.926H3c-.552 0-1 .452-1 1.01 0 .557.448 1.009 1 1.009h.14c.523 1.944 2.385 3.202 4.365 2.947C9.485 15.713 10.976 14.014 11 12c0-.558.448-1 1-1s1 .453 1 1.01c.024 2.015 1.515 3.703 3.495 3.957 1.98.255 3.842-1.003 4.365-2.947H21c.552 0 1-.452 1-1.01 0-.557-.448-1.01-1-1.01zM7 14a2 2 0 11-.001-3.999A2 2 0 017 14zm10 0a2 2 0 11-.001-3.999A2 2 0 0117 14z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function orders(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 6a1 1 0 011 1v15l-2-1-2 1-2-1-2 1-2-1-2 1-2-1-2 1V7a1 1 0 011-1h14zm-1 2H4v10.764l2 1 2-1 2 1 2-1 2 1 2-1V8zm6 10l-2-1V4H6V3a1 1 0 01.883-.993L7 2h14a1 1 0 01.993.883L22 3v15zm-8-4a1 1 0 010 2H6a1 1 0 010-2h8zm0-4a1 1 0 010 2H6a1 1 0 010-2h8z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function organic(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19 15c.6 0 1 .5 1 1v.5h-3.5v3h2V18H20v2c0 .5-.4 1-1 1h-3c-.6 0-1-.5-1-1v-4c0-.5.4-1 1-1zm-6.5 0c.8 0 1.5.7 1.5 1.5v1c0 .6-.4 1.1-.9 1.4L14 21h-1.5l-.9-2h-1.1v2H9v-6zm-6 0c.753 0 1.417.62 1.493 1.36L8 16.5v3c0 .753-.62 1.417-1.36 1.493L6.5 21h-2a1.5 1.5 0 01-1.493-1.356L3 19.5v-3a1.5 1.5 0 011.356-1.493L4.5 15h2zm0 1.5h-2v3h2v-3zm6 0h-2v1h2v-1zm5-13.5s-.392 7.2-2.784 9.594a4.814 4.814 0 01-5.466.942 10.976 10.976 0 013.706-6.41c-2.248 1.163-4.05 3.116-5.06 5.454a4.817 4.817 0 01.013-6.795C10.302 3.392 17.5 3 17.5 3z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function pastPurchase(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.025 3a.994.994 0 01.708.29l8.972 9a1 1 0 010 1.42l-7.038 7.03A.921.921 0 0113 21a1.07 1.07 0 01-.739-.29l-8.972-9A1.003 1.003 0 013 11.07V4c0-.552.446-1 .997-1h7.028zM10.6 5H4.994L5 10.7l8 7.95L18.602 13 10.6 5zm.697 7.057a1.501 1.501 0 011.703.686 1.5 1.5 0 011.285-.73 1.518 1.518 0 011.415 1.52c.01.57-.192 1.124-.568 1.55-.618.666-1.224 1.3-1.932 1.867a.34.34 0 01-.4 0 18.987 18.987 0 01-2.032-1.866 2.28 2.28 0 01-.568-1.55 1.509 1.509 0 011.097-1.477zM7 6a1 1 0 110 2 1 1 0 010-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function pdf(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.39 2c.277 0 .542.117.73.32l5.63 6A1 1 0 0120 9v12a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1h9.39zM13 4H5v16h13V9.36L13 4zm-6.5 6c1.22.03 2.5.6 2.5 2a2.09 2.09 0 01-2 2v1.5c0 .25-.25.5-.52.5a.483.483 0 01-.48-.5v-5a.5.5 0 01.5-.5zm3.5 0c1.35 0 3.5.81 3.5 3s-1.82 3-3.5 3a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm6.5 0a.5.5 0 110 1H15v1h1.4a.5.5 0 010 1H15v2.5c-.016.267-.231.506-.5.5a.5.5 0 01-.5-.498v-5.004a.5.5 0 01.5-.498h2zm-6 1v3.9l.15-.005c1.034-.068 1.85-.84 1.85-1.895-.01-1.25-1.19-1.84-2-2zM7 11v2c.5 0 1-.33 1-1 0-.67-.55-1-1-1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function personalized(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16.036 4.496c2.228 1.998 2.582 5.35.764 7.704.272.167.548.357.8.55.29.221.443.577.39.93a1.009 1.009 0 01-.643.784A1.116 1.116 0 0116.3 14.3a6.57 6.57 0 00-1.55-.9c-.336-.136-.6-.402-.65-.75-.05-.348.082-.734.37-.946C15.9 10.65 16.25 8.85 15.7 7.45 15.15 6.05 13.711 4.993 12 5c-1.711.007-3.15 1.05-3.7 2.45-.55 1.4-.2 3.15 1.2 4.25.283.222.45.552.4.9-.05.348-.263.668-.6.8-2.413.943-4.1 3.118-4.3 5.6h5a1 1 0 010 2H4a1 1 0 01-1-.999v-.419c-.005-2.992 1.587-5.777 4.213-7.369-1.836-2.384-1.497-5.726.784-7.717 2.28-1.991 5.81-1.998 8.039 0zm4.667 9.785c.386.385.397 1.02.024 1.418l-4.807 5.02a.954.954 0 01-1.353 0l-2.257-2.205a1.028 1.028 0 01-.284-.967 1 1 0 01.671-.736.963.963 0 01.955.23l1.557 1.553 4.117-4.288a.954.954 0 011.377-.025z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function phone(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10.565 13.446a12.651 12.651 0 01-1.684-3.905c-.11-.452.088-.922.487-1.16l.476-.283 1.028-.613-1.505-2.36-.581.35c-2.17 1.292-2.292 5.271.031 8.927 2.374 3.658 6.127 5.347 8.317 4.043l.533-.321-1.5-2.353-1.084.647-.477.284c-.38.227-.862.193-1.207-.085a13.018 13.018 0 01-2.8-3.122l-.034-.049zm1.775-1.159c.51.81 1.127 1.552 1.837 2.206l.957-.571a2.1 2.1 0 012.789.664l1.605 2.517c.583.953.28 2.186-.683 2.784l-.623.375c-3.359 2-8.26-.206-11.187-4.716-2.891-4.55-2.73-9.868.663-11.888l.646-.388a2.097 2.097 0 012.783.677l1.605 2.516c.584.954.282 2.186-.685 2.786l-.898.537c.274.85.658 1.667 1.142 2.43a.982.982 0 01.049.071z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function photo(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M4 6a1 1 0 011 1v10a2 2 0 002 2h9a1 1 0 010 2H7c-2.21 0-4-1.79-4-4V7a1 1 0 011-1zm16-3a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V4a1 1 0 011-1h12zm-1 2H9v10h10V5zm-4 4l3 5h-8l2-3 1 1.4L15 9z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function pickup(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      aria-hidden="true"
    >
      <path
        d="M15.458 7.095h3.868V5.548h-3.869v1.547h.001zm5.416 0h4.643v20.892H9.267v-6.964h1.548v5.416h13.153V8.643h-3.095v1.547h-1.548V8.643h-3.869v1.547h-1.547V8.643h-3.094v7.737H5.391v-1.547h3.876V7.095h4.643V5.548c0-.855.692-1.548 1.547-1.548h3.869c.855 0 1.548.693 1.548 1.548v1.547zM3.845 14.748a.858.858 0 10.002 1.716.858.858 0 00-.002-1.716zm3.097 4.728h3.873v-1.549H6.942v1.549zm-.685-.774a.86.86 0 11-1.72-.003.86.86 0 011.72.003z"
        fill={checkColor(color)}
        fillRule="evenodd"
        data-testid="ads-icon__path"
      />
      <path
        d="M13.91 14.682v5.684h1.583v-3.304c0-.49.042-.823.123-.996.084-.174.252-.261.504-.261.206 0 .336.06.393.179.059.12.088.383.088.786v3.596h1.582v-3.304c0-.505.037-.841.114-1.007.077-.166.242-.25.494-.25.21 0 .347.064.408.19.06.13.091.404.091.826v3.545h1.584V16.66c0-.648-.045-1.088-.13-1.322a1.079 1.079 0 00-.464-.554c-.22-.136-.52-.201-.893-.201-.67 0-1.133.296-1.39.885-.14-.589-.549-.885-1.22-.885-.646 0-1.103.296-1.372.885v-.786H13.91"
        fill="#DB232D"
        fillRule="nonzero"
      />
    </svg>
  );
}

export function pill(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 4.929A5 5 0 0119.071 12L12 19.071A5 5 0 014.929 12L12 4.929zm1.414 1.414L9.88 9.88l4.242 4.242 3.536-3.535a3 3 0 10-4.243-4.243z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function pizza(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 2c2.51 0 5.02.59 7.53 1.772L20 4l-8 18L4 4c2.667-1.333 5.333-2 8-2zm0 4.5c-1.467 0-2.935.22-4.406.663l.963 2.17a1.5 1.5 0 111.179 2.649L12 17.076l.967-2.174a1.5 1.5 0 111.216-2.738l2.223-5A15.17 15.17 0 0012 6.5zm1.5.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0113.5 7zM12 4l-.44.007a14.982 14.982 0 00-4.384.82l-.49.177-.044.017.543 1.221A16.274 16.274 0 0112 5.5c1.606 0 3.212.248 4.815.742l.542-1.221-.489-.178a15 15 0 00-4.384-.835L12 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function plu(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.902 2.009c.077.003.134.006.17.009A.998.998 0 0119 3.03a6.346 6.346 0 01-.395 2.04c-.225.602-.54 1.123-.97 1.531l-.09.079C19.752 7.726 21 10.225 21 13.522c0 3.604-2.362 7.18-5.597 8.348-.737.266-1.177.127-2.408-.456l-.18-.085c-.43-.2-.68-.282-.815-.282-.12.005-.306.087-.732.33-1.042.599-1.498.765-2.274.499C5.422 20.65 3 17.325 3 13.522c0-3.715 1.302-6.2 3.963-7.158 1.608-.578 2.771-.46 4.143.129l-.121-.049a.983.983 0 01-.036-.267c0-1.29-.61-1.948-2.108-2.19a1 1 0 11.318-1.974c1.727.278 2.91 1.095 3.453 2.37.214-.46.484-.856.813-1.185.542-.544 1.309-.863 2.243-1.04a10.118 10.118 0 012.234-.15zM15 13l.001 6.882c.348-.15.683-.34 1-.563L16 13h1V8.656a3.129 3.129 0 00-.468-.24 5.35 5.35 0 00-.533-.19L16 13h-1V8.095a3.768 3.768 0 00-.998.207L14 13h1zm3.988 0H17v5.447c1.215-1.293 2-3.115 2-4.925 0-.178-.004-.352-.012-.522zM6 9.459c-.6.82-.93 1.989-.99 3.541H6v4.076c.282.46.617.885 1 1.267V13H6zm10.842-5.44c-.27.02-.541.053-.802.102-.575.109-.996.284-1.198.487-.277.277-.498.7-.65 1.273 1.032-.149 1.724-.405 2.067-.73.185-.175.346-.44.471-.778.043-.113.08-.232.112-.353zM11 13V8.619a8.867 8.867 0 01-.343-.142l-.342-.15A7.377 7.377 0 0010 8.201V13H9V8h.18c-.367-.038-.74 0-1.179.126L8 13h1v6.73c.209.095.424.181.644.257-.004-.002.01-.009.048-.028l.131-.067a6.23 6.23 0 00.176-.093L10 13h1v6.265c.31-.134.572-.197.897-.213l.103-.003c.334 0 .64.063 1 .192V13h-2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function prescribers(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M22 12c-.021-1.52-1.176-2.818-2.687-2.976a2.998 2.998 0 00-3.237 2.323 2.998 2.998 0 001.925 3.488v.13C18.001 17.191 16.225 19 14 19a3.97 3.97 0 01-3.99-4v-1c5.057-.9 5.942-9.034 5.992-9.354a1.007 1.007 0 00-.25-.78 1.005 1.005 0 00-.75-.33h-2.119a.999.999 0 00-1.879.43v1.08a1 1 0 001 1c.347-.01.665-.199.84-.5h.999C13.353 7.626 12.068 12 9 12c-3.07 0-4.354-4.364-4.804-6.474h.95c.174.301.492.49.84.5a1 1 0 001-1v-1.06a1 1 0 00-1.88-.44h-2.1a1.002 1.002 0 00-.999 1.12C2.007 4.966 3.072 13.04 8 14v1c0 3.333 2.668 6 6 6s6-2.702 6-6.035v-.13c1.213-.428 2.018-1.549 2-2.835zm-4 0a1 1 0 012 0c.006.565-.436.973-1 1a1 1 0 01-1-1z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function prescriptions(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M14.59 2c.558 0 1.01.448 1.01 1H17c.552 0 1 .444 1 .993v2.014A.996.996 0 0117 7v14a1 1 0 01-1 1H8a1 1 0 01-1-1V7c-.552 0-1-.444-1-.993V3.993A.996.996 0 017 3h1.4c0-.552.452-1 1.01-1h5.18zM15 6H9v14h6V6z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function print(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M18.49 8H18V4a1 1 0 00-1-1H7a1 1 0 00-1 1v4h-.5A2.5 2.5 0 003 10.5V15a1 1 0 001 1h2v4a1 1 0 001 1h10a1 1 0 001-1v-4h2a1 1 0 001-1v-4.5A2.51 2.51 0 0018.49 8zM8 5h8v3H8V5zm0 14v-5h8v5H8zm11-5h-1v-1a1 1 0 00-1-1H7a1 1 0 00-1 1v1H5v-3.5a.5.5 0 01.5-.5h13a.5.5 0 01.5.5V14z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function propane(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16 2a1 1 0 011 1v2a3 3 0 013 3v11a3 3 0 01-3 3H7a3 3 0 01-3-3V8a3 3 0 012.824-2.995L7 5V3a1 1 0 011-1h8zm-1 2H9v2.943l-2.06.059a1 1 0 00-.934.886L6 8v5h3v2H6v4a1 1 0 00.883.993L7 20h10a1 1 0 00.993-.883L18 19v-4h-2v-2h2V8a1 1 0 00-.883-.993L17 7h-2V4zm-1 7c.55 0 1 .45 1 1v2.5a1 1 0 01-1 1h-2.5V17H10v-5c0-.55.45-1 1-1zm-.5 1.5h-2V14h2v-1.5zM13 5a1 1 0 010 2h-2a1 1 0 010-2h2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function receipt(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M18 4v9h3c.573 0 1 .447 1 .999v4c0 1.595-1.343 3-3 3H4.95A2.918 2.918 0 012 18.08V4l2 1 2-1 2 1 2-1 2 1 2-1 2 1 2-1zm-4 2l-2 1-2-1-2 1-2-1-2 1v11.08A.92.92 0 005 19h11V7l-2-1zm6 9h-2v3c0 .489.503 1 1 1s1-.511 1-1v-3zm-9.418-2.905H9.571a.751.751 0 01-.526-.225.736.736 0 01-.212-.528c0-.412.354-.894 1.264-.894a1.37 1.37 0 011.295.713.841.841 0 001.183.201.87.87 0 00.202-1.175 3.031 3.031 0 00-1.84-1.275v-.16A.849.849 0 0010.092 8a.848.848 0 00-.845.752v.16a2.446 2.446 0 00-2.243 2.572 2.452 2.452 0 002.527 2.298h1.011a.746.746 0 01.738.753c0 .411-.556.923-1.264.923a1.438 1.438 0 01-1.204-.662c-.202-.573-.627-.854-1.082-.723a.834.834 0 00-.597.903 2.46 2.46 0 002.084 2.009v.08a.84.84 0 00.393.806.855.855 0 00.903 0 .84.84 0 00.393-.806v-.12a2.437 2.437 0 00-.324-4.85z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function refillByScan(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 6h3v3a1 1 0 002 0V5a1 1 0 00-1-1h-4a1 1 0 000 2zM4 9V6h3a1 1 0 000-2H3a1 1 0 00-1 1v4a1 1 0 002 0zm3 9H4v-3a1 1 0 00-2 0v4a1 1 0 001 1h4a1 1 0 000-2zm13-3v3h-3a1 1 0 000 2h4a1 1 0 001-1v-4a1 1 0 00-2 0zm-6.39-1.59l1.59-1.61a.501.501 0 00-.71-.7l-1.59 1.65-1-1A2 2 0 0011 8H9.5a.5.5 0 00-.5.5v5a.5.5 0 001 0v-1.56h.66l1.54 1.52-1.59 1.61a.501.501 0 00.71.7l1.59-1.61 1.61 1.59a.5.5 0 00.864-.214A.58.58 0 0015.2 15l-1.59-1.59zM10 9h1a1 1 0 010 2h-1V9z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function reminder(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16 2a3.999 3.999 0 013.168 6.443A7.978 7.978 0 0120 12a7.985 7.985 0 01-3.192 6.394l1.9 1.899a1 1 0 01-1.415 1.414l-2.29-2.29A7.969 7.969 0 0112 20a7.973 7.973 0 01-3.003-.583l-2.29 2.29a1 1 0 01-1.414-1.414l1.899-1.899A7.985 7.985 0 014 12c0-1.278.3-2.486.832-3.557A3.999 3.999 0 018 2c1.465 0 2.777.795 3.475 2.017a8.294 8.294 0 011.05 0A4.002 4.002 0 0116 2zm-4 4a6 6 0 100 12 6 6 0 000-12zm0 2a1 1 0 011 1v2h2a1 1 0 010 2h-3a1 1 0 01-1-1V9a1 1 0 011-1zM8 4a2 2 0 00-1.907 2.605 8.005 8.005 0 013.196-2.134A1.992 1.992 0 008 4zm8 0c-.486 0-.938.175-1.29.47a8.007 8.007 0 013.197 2.135A2 2 0 0016 4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function restroom(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 3a.5.5 0 01.5.5v17a.5.5 0 01-1 0v-17A.5.5 0 0112 3zM7.5 8a2 2 0 012 2v5a1 1 0 01-1 1H8v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4h-.5a1 1 0 01-1-1v-5a2 2 0 012-2h3zm10.896 0a2 2 0 011.952 1.566L22 17h-2v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-2l1.652-7.434A2 2 0 0117.604 8h.792zM6 3a2 2 0 11.001 3.999A2 2 0 016 3zm12 0a2 2 0 11.001 3.999A2 2 0 0118 3z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function rewards(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9 16.4a1 1 0 011 1V21a1 1 0 01-2 0v-3.6a1 1 0 011-1zm6 0a1 1 0 011 1V21a1 1 0 01-2 0v-3.6a1 1 0 011-1zm-3 .6a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm1.695-14.354a2.438 2.438 0 012.929 1.697 2.441 2.441 0 011.695 2.932 2.442 2.442 0 010 3.384 2.44 2.44 0 01-1.695 2.931 2.437 2.437 0 01-2.929 1.697A2.459 2.459 0 0112 16a2.456 2.456 0 01-1.695-.683 2.437 2.437 0 01-2.929-1.697 2.44 2.44 0 01-1.695-2.951 2.442 2.442 0 010-3.384 2.44 2.44 0 011.685-2.942 2.438 2.438 0 012.939-1.697 2.547 2.547 0 013.39 0zm-1.68 1.322a.44.44 0 00-.416.295 1.004 1.004 0 01-1.605.422.44.44 0 00-.722.421 1.005 1.005 0 01-1.144 1.145.44.44 0 00-.411.713 1.006 1.006 0 01-.421 1.576.442.442 0 000 .833 1.003 1.003 0 01.421 1.607.443.443 0 00.422.723 1.002 1.002 0 011.153 1.154.44.44 0 00.722.422c.167-.167.387-.27.622-.291.413.001.784.256.933.642a.44.44 0 00.832 0 1.004 1.004 0 011.605-.371.44.44 0 00.722-.422 1.004 1.004 0 011.154-1.154.451.451 0 00.461-.221.452.452 0 000-.512 1.008 1.008 0 01.421-1.577.44.44 0 000-.833 1.003 1.003 0 01-.491-1.576.452.452 0 000-.512.453.453 0 00-.462-.221 1.002 1.002 0 01-1.103-1.125.442.442 0 00-.702-.421 1 1 0 01-.895.193 1 1 0 01-.68-.615.44.44 0 00-.416-.295zM12 6l.9 1.8h1.8l-1.3 1.3.6 1.9-2-1.1-2 1.1.7-1.9-1.4-1.3h1.8L12 6z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function savings(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.804 4c.35 0 .687.138.932.383.277.281.425.66.412 1.05a1.76 1.76 0 01-.371 1.12c.238.038.48.057.722.058.277 0 .501.22.501.491s-.224.49-.501.49a4.37 4.37 0 01-1.745-.313c-.389.15-.798.247-1.214.284a7.48 7.48 0 011.254 4.251c.046 3.403-3.146 6.342-3.742 6.855l-.09.076a1.01 1.01 0 01-.651.235h-2.337a1.012 1.012 0 01-.747-.321.971.971 0 01-.255-.759v-.127h-1.354l-.452.746c-.18.298-.508.48-.862.48H6.707c-.31.006-.604-.13-.799-.365a.968.968 0 01-.194-.842l.37-2.238H4.27a1.001 1.001 0 01-.943-.638l-1.264-3.318c-.114-.3-.072-.636.114-.9s.492-.423.82-.425h.741l.913-2.238-.281-2.278a.974.974 0 01.406-.857c.277-.2.638-.246.958-.124l2.276.893c1.435-.634 3-.936 4.573-.884a7.47 7.47 0 014.834 1.551c.208.135.445.223.692.256.229-.005.457-.028.682-.07a1.93 1.93 0 01-.341-1.099c-.022-.366.11-.726.366-.995s.613-.423.988-.428zm-7.22 2.817a7.258 7.258 0 00-4.283.982l-1.735-.58.18.983-.27.706-1.354 3.387H4.43l.522 1.365h2.306c.296-.004.58.12.773.34a.97.97 0 01.23.798l-.371 2.239h.842l.422-.727c.18-.298.508-.48.862-.48h3.009a1.01 1.01 0 01.747.32c.19.206.284.482.255.759v.128h.873c.752-.747 2.898-2.945 2.868-5.164-.02-1.522-.572-5.056-5.185-5.056zM7.496 9.5a.5.5 0 110 1 .5.5 0 010-1zm12.307-4.42c-.17 0-.351.108-.351.442 0 .229.047.378.247.578.207-.149.422-.328.445-.578 0-.275-.17-.442-.341-.442z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function shopAndScan(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M16.869 2C17.491 2 18 2.51 18 3.135v17.731C18 21.49 17.491 22 16.869 22H7.132C6.51 22 6 21.49 6 20.866V3.135C6 2.51 6.51 2 7.132 2h9.737zM16 18H8v2h8v-2zm0-14H8v12h8V4zm-5.471 4.657v.7c.194-.356.566-.578.97-.58a.865.865 0 01.97.666 1.088 1.088 0 011.122-.666 1 1 0 011.069 1.092v3.449h-1.188v-3.236c0-.453-.884-.38-.884 0v3.276h-1.182v-3.329c0-.44-.884-.453-.884 0v3.289H9.348V8.657h1.181zM14 5v1h-4V5h4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function shoppingBag(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M15 3a1 1 0 011 .972V6h2a1 1 0 011 .972V20a1 1 0 01-.972 1H6a1 1 0 01-1-.972V7a1 1 0 01.972-1H8V4a1 1 0 01.972-1H15zM8 8H7v11h10V8h-1a1 1 0 01-2 .028V8h-4a1 1 0 01-.972 1H9a1 1 0 01-1-.972V8zm6-3h-4v1h4V5z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function shoppingCart(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9 18a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 019 18zm7 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0116 18zM5.3 3c.355.007.69.223.846.56L7 5h13c.328.001.678.155.85.45.172.295.196.69.049 1l-2.843 6a.962.962 0 01-.856.55H9.6l-1.2 2H17c.523 0 1 .448 1 1s-.477 1-1 1H7c-.35.007-.73-.178-.9-.5-.17-.322-.089-.79.1-1.1l2.419-4.19L4.895 5H3.9c-.523 0-1-.448-1-1s.477-1 1-1zm13.22 4H8.297l2.368 4h5.96l1.895-4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function specialOffers(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M15.49 7c.4-.003.784.154 1.067.436.284.281.443.664.443 1.064v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 013 19.51V8.5A1.5 1.5 0 014.49 7h11zM15 9H5v10h10V9zm2.81-6A3.176 3.176 0 0121 6.18V17a1 1 0 01-2 0V7.18A2.18 2.18 0 0016.82 5H8a1 1 0 010-2h9.81zm-7.808 7c.368 0 .667.303.667.676v.151c.574.15 1.074.508 1.402 1.01a.7.7 0 01-.159.937.66.66 0 01-.925-.161 1.07 1.07 0 00-.995-.575c-.716 0-.995.383-.995.716a.605.605 0 00.165.424.583.583 0 00.412.181h.826c.51.006.995.216 1.352.585.356.369.553.866.548 1.383a1.94 1.94 0 01-1.681 1.937v.06a.672.672 0 01-.667.676.671.671 0 01-.666-.676v-.06a2.002 2.002 0 01-1.631-1.594.666.666 0 01.467-.727c.348-.1.686.121.846.585.213.346.592.55.994.535.557 0 .995-.403.995-.736a.6.6 0 00-.165-.424.582.582 0 00-.412-.182h-.826c-1.032.014-1.892-.8-1.95-1.846a1.948 1.948 0 011.732-2.058v-.141c0-.373.298-.676.666-.676z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function targeted(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 4a8 8 0 110 16 8 8 0 010-16zm0 2a6 6 0 100 12 6 6 0 000-12zm0 3a3 3 0 110 6 3 3 0 010-6z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function tobacco(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11 2v3h6v1h1a1 1 0 011 1v14a1 1 0 01-1 1H6a1 1 0 01-1-1V7a1 1 0 011-1h1l1 1V2h3zm1 12.202l-5 3.332V20h10v-2.465l-5-3.333zm5-5.374l-.293.293c-.516.516-1.2.825-1.923.872l-.198.007H9.414a3 3 0 01-1.976-.743l-.145-.136L7 8.83v7.503L12 13l5 3.333V8.828zM11 8h1V6h-1v2zm-1-1H8.999v.91a1 1 0 00.415.09H10V7zm3.999-1H13v2h1l-.001-2zm2 0h-1L15 7.91a.994.994 0 00.293-.203L15.999 7V6zM10 3H9l-.001 3H10V3z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function thumbprint(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.088 9.292a7.237 7.237 0 012.223 5.06 2.76 2.76 0 01-2.74 2.551 2.758 2.758 0 01-2.738-2.551 1.809 1.809 0 00-.564-1.262 1.776 1.776 0 00-1.283-.486 1.776 1.776 0 00-1.284.486c-.347.328-.55.782-.563 1.262a5.685 5.685 0 001.668 4.054 6.038 6.038 0 002.891 1.693.45.45 0 01.312.55.437.437 0 01-.419.351h-.116a6.929 6.929 0 01-3.31-1.883 6.586 6.586 0 01-1.927-4.693 2.715 2.715 0 01.827-1.893 2.67 2.67 0 011.912-.747c.71-.016 1.397.252 1.911.747s.812 1.176.828 1.893c.067.982.876 1.744 1.851 1.744s1.784-.762 1.852-1.744a6.332 6.332 0 00-1.961-4.423 6.214 6.214 0 00-4.49-1.712 6.49 6.49 0 00-5.88 3.604 5.832 5.832 0 00-.527 2.513 9.005 9.005 0 00.598 3.243.444.444 0 01-.259.576.436.436 0 01-.57-.261 10.095 10.095 0 01-.652-3.603 6.81 6.81 0 01.607-2.91 7.382 7.382 0 016.683-4.135 7.102 7.102 0 015.12 1.976zm.001 5.087c0 .249-.2.45-.446.45s-.446-.201-.446-.45c-.073-2.244-1.926-4.006-4.149-3.946-2.222-.06-4.076 1.702-4.149 3.946a7.087 7.087 0 00.83 3.46c.417.805.96 1.538 1.606 2.17a.463.463 0 010 .64.493.493 0 01-.34.135.42.42 0 01-.311-.135 9.084 9.084 0 01-1.785-2.37 8.047 8.047 0 01-.892-3.9c.068-2.743 2.324-4.912 5.041-4.847 2.717-.065 4.973 2.104 5.041 4.847zm-5.14-.478c.247 0 .447.202.447.45a3.875 3.875 0 001.731 3.199c.67.442 1.458.665 2.257.64.3-.008.598-.038.893-.09a.45.45 0 01.424.158.461.461 0 01.076.45.453.453 0 01-.349.292 6.01 6.01 0 01-1.052.126 4.756 4.756 0 01-2.758-.829 4.792 4.792 0 01-2.114-3.945c0-.249.2-.45.446-.45zm4.632-7.62a9.253 9.253 0 013.337 2.918.454.454 0 01-.325.712.444.444 0 01-.407-.19 8.39 8.39 0 00-3.016-2.639 9.3 9.3 0 00-8.369 0 8.465 8.465 0 00-3.025 2.703.384.384 0 01-.339.153.464.464 0 01-.259-.081.457.457 0 01-.089-.631 9.23 9.23 0 013.32-2.937 10.185 10.185 0 019.172-.009zm.794-1.91a.452.452 0 01.24.511.447.447 0 01-.445.344v-.009a.414.414 0 01-.206-.054 10.104 10.104 0 00-4.96-1.279 10.103 10.103 0 00-4.953 1.28.444.444 0 01-.447-.012.453.453 0 01.019-.781 11.226 11.226 0 0110.752 0z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function tipsRatings(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.31 2.088a.73.73 0 01.36.36l2.667 5.762 6.047.964a.74.74 0 01.41 1.248L17.4 14.885l1.05 6.312a.739.739 0 01-1.085.768L12 19.01l-5.372 2.88a.74.74 0 01-1-.302c-.077-.145-.105-.31-.077-.472L6.6 14.9l-4.4-4.521a.739.739 0 01.418-1.245l6.045-.924 2.667-5.762a.738.738 0 01.98-.36zM12 5L9.7 9.7l-5 .8 3.6 3.7-.8 5.2L12 17l4.4 2.4-.8-5.2 3.6-3.7-5-.8L12 5zm.061 4.4c.281 0 .519.202.56.473l.003.023v.106c.504.116.943.417 1.228.842a.57.57 0 01-.135.775.568.568 0 01-.789-.133.914.914 0 00-.863-.47c-.607 0-.843.318-.843.59a.484.484 0 00.141.348c.086.087.202.14.325.148h.7c.899.012 1.62.734 1.612 1.617a1.613 1.613 0 01-1.362 1.579l-.034.005v.08a.552.552 0 01-.262.532.577.577 0 01-.602 0 .555.555 0 01-.264-.509l.002-.023v-.053a1.635 1.635 0 01-1.39-1.326.552.552 0 01.399-.596c.303-.086.586.1.721.477.175.27.477.435.803.437.472 0 .843-.337.843-.61a.497.497 0 00-.466-.495l-.027-.001h-.674c-.887.026-1.633-.647-1.684-1.517a1.619 1.619 0 011.463-1.694l.032-.003v-.106a.563.563 0 01.563-.496z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function transferPrescriptions(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9 13.7c-1.206 1.524-3 2.298-5 2.3a1 1 0 100 2c2.4-.003 4.628-.937 6.2-2.7-.28-.36-.68-.894-1.2-1.6zm9.705-9.404a1 1 0 00-1.089-.221A1 1 0 0017 5v1.2c-1.8.4-3.074 1.28-4.183 2.508.273.36.673.914 1.2 1.661C14.806 9.433 15.8 8.6 17 8.4V9a1.012 1.012 0 001.725.699l2-2.001c.184-.194.275-.45.275-.698 0-.257-.1-.508-.296-.703l-2-2.001zM20.7 16.3l-1.995-1.999a1.001 1.001 0 00-1.709.701L17 15.7c-2.12-.66-3.334-2.31-4.683-4.23C10.537 8.878 8.508 6 4 6a.998.998 0 100 1.997C7.5 8 8.998 10.12 10.687 12.58c1.49 2.131 3.164 4.51 6.313 5.22V19a1 1 0 00.616.925 1 1 0 001.089-.221l1.995-2.003c.19-.194.299-.45.3-.701a1.003 1.003 0 00-.3-.7z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function updateInsurance(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M21 4a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1zm-1 2H4v12h16V6zm-4.51 8a.5.5 0 010 1h-2a.5.5 0 010-1h2zM8.535 9a3.394 3.394 0 001.831.663c.368.022.65.336.633.704 0 .907-.152 1.808-.452 2.664a5.599 5.599 0 01-1.68 1.85.671.671 0 01-.764 0 5.618 5.618 0 01-1.7-1.85 8.078 8.078 0 01-.402-2.654.673.673 0 01.634-.703 3.394 3.394 0 001.84-.664zm-.06 1.156c-.25.13-.513.234-.784.312a4.982 4.982 0 01-.704.15 6.106 6.106 0 00.322 2.011c.29.525.684.987 1.156 1.357a4.47 4.47 0 001.167-1.327 6.13 6.13 0 00.321-2.01 5.022 5.022 0 01-.694-.151 4.2 4.2 0 01-.784-.312zM17.49 12a.5.5 0 010 1h-4a.5.5 0 010-1h4zm0-2a.5.5 0 010 1h-4a.5.5 0 010-1h4z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function weeklyAd(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 4a1 1 0 011 1v7h3c.573 0 1 .447 1 .999V17c0 1.594-1.343 3-3 3H4.95A2.917 2.917 0 012 17.08V5a1 1 0 011-1h14zm-1 2H4v11.08A.917.917 0 005 18h11V6zm4 8h-2v3c0 .49.503 1 1 1s1-.51 1-1v-3zm-6-3.18v-1a1.497 1.497 0 00-.423-1.195 1.495 1.495 0 00-1.187-.445 1.64 1.64 0 00-1.69 1 1.301 1.301 0 00-1.46-1 1.67 1.67 0 00-1.46.87V8H6v7h1.8v-4.9c0-.68 1.3-.66 1.3 0V15h1.8v-4.9c0-.57 1.31-.64 1.31.04V15H14v-4.18z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function wex(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17 4c.672 0 1.073.38 1.346.835.154.255.283.526.413.794.354.733.704 1.467 1.053 2.202.486 1.023.973 2.046 1.454 3.071.207.44.425.877.595 1.331.3.807-.077 1.633-.721 2.068-.307.208-.666.338-1.016.51L18.16 12.3l1.976-2.529h-1.417l-1.269 1.617-1.265-1.611h-1.42l1.973 2.522-2.078 2.661h1.417l1.374-1.75 1.387 1.77h.836a5.78 5.78 0 01-.666.355l-2.996 1.42c-.734.348-1.468.699-2.203 1.047-.86.407-1.722.813-2.583 1.219-.861.406-1.723.81-2.583 1.219-.257.122-.51.252-.764.38-.049.025-.29.104-.362.114-.366.052-.72.02-1.065-.097a1.56 1.56 0 01-.871-.743 11.31 11.31 0 01-.341-.667c-.355-.74-.706-1.48-1.058-2.22-.423-.89-.856-1.778-1.266-2.675-.316-.692-.63-1.299-.874-2.033a1.176 1.176 0 01-.041-.3c-.002-.202.037-.407.04-.433.062-.394.244-.666.542-.925.373-.324.837-.484 1.3-.712v.256c0 .885-.006 1.77.005 2.656.003.255.032.515.088.765.17.753.923 1.34 1.705 1.338l.851-1.081.103.184c.323.547.792.871 1.432.917.757.055 1.862-.6 1.883-1.768.019-1.087.008-2.175.01-3.262 0-.047-.008-.094-.014-.149H8.86v.262c0 .962.002 1.924-.002 2.886 0 .145-.013.294-.052.433a.598.598 0 01-.515.459.635.635 0 01-.679-.308.948.948 0 01-.13-.52V9.772H6.38v.285c0 .913 0 1.827-.002 2.74 0 .146-.01.293-.03.437a.676.676 0 01-.603.598c-.355.025-.602-.14-.695-.496a1.997 1.997 0 01-.042-.496c-.004-.934-.002-1.869-.003-2.803 0-.081-.007-.163-.011-.262h-.677c.037-.06.08-.09.128-.113l1.884-.893c.848-.402 1.697-.802 2.544-1.205.76-.361 1.517-.727 2.277-1.087.973-.461 1.944-.93 2.924-1.375.627-.285 1.227-.629 1.866-.886C16.142 4.133 16.51 4 17 4zm-4.333 5.66a2.665 2.665 0 00-2.426 2.818c.079 1.283 1.104 2.39 2.442 2.487 1.526.111 2.59-1.057 2.728-1.855a.831.831 0 00-.69-.139c-.257.052-.45.2-.622.395a1.58 1.58 0 01-2.184.202c-.043-.033-.09-.062-.142-.097l-.758.336-.017-.021.502-.66c-.155-.371-.275-.738-.17-1.141.102-.4.307-.73.642-.973.464-.336 1.246-.386 1.623-.096l-1.63 2.09.032.037 3.381-1.603c-.277-1.042-1.452-1.9-2.711-1.78zM21.5 8.9a.6.6 0 11-.001 1.201A.6.6 0 0121.5 8.9zm0 .1a.5.5 0 100 1 .5.5 0 000-1zm-.018.142l.07.002a.388.388 0 01.097.017.16.16 0 01.083.069c.021.033.032.07.032.113a.19.19 0 01-.048.133.223.223 0 01-.141.066.321.321 0 01.077.06c.014.015.03.037.05.066l.032.05.088.14h-.173l-.105-.156-.033-.049a.706.706 0 00-.043-.056.109.109 0 00-.043-.03l-.03-.006-.043-.002h-.03v.299h-.144v-.716h.304z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function yourStore(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M19.982 5.82a1 1 0 00-.998-.82H5.016a.998.998 0 00-.998.8l-.998 5a1.003 1.003 0 00.998 1.2h.998v6c0 .552.446 1 .997 1h6.985a1 1 0 00.998-1v-6h2.993v6a.999.999 0 101.995 0v-6h.998a.997.997 0 00.997-1.2l-.997-4.98zM5.824 7h12.342l.599 3H5.235l.589-3zM12 17H7.011v-5H12v5z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}
